

<div class="row">
	<input type='text'
           style='color:black;padding: 0px 0px 0px 10px; margin:0px 0px 0px 15px; height: 35px;'
		   placeholder='Search..'
		   (keyup)='filterConfigs(null, "search")' [(ngModel)]="searchText"/>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable
			   class='material striped datatable'
			   [rows]='display'
			   [columnMode]='"force"'
			   [headerHeight]='40'
			   [footerHeight]='20'
			   [scrollbarV]="true"
			   [rowHeight]="40"
			   [reorderable]="true"
			   [sorts]="[{prop: 'name', dir: 'asc'}]"
			   [messages]="{emptyMessage:'Nothing to see here'}">						

	<ngx-datatable-column prop="name" [sortable]="true" [minWidth]="400" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Config Name
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.name}}
		</ng-template>
	</ngx-datatable-column>  		   
		
	<ngx-datatable-column prop="path" [sortable]="true" [minWidth]="300" [maxWidth]="600" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Object Path
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.path}}
		</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column prop="bucketName" [sortable]="true" [minWidth]="200" [maxWidth]="600" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Bucket Name
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.bucketName}}
		</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column name="lastModified" [minWidth]="200">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Last Modified
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.lastModified | date:'EEEE, MMMM d, y'}}
		</ng-template>
	  </ngx-datatable-column>

		<ngx-datatable-column prop="edit" [minWidth]="120" >
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span>
					Actions
				</span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
				<button type="button" (click)="editConfig(row.cueConfigId)">Edit</button>
			</ng-template>
		</ngx-datatable-column>	


</ngx-datatable>


				

							
				 
